import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAirline } from "../../api/apiAirlines";
import parseError from "../../utils/parseError";

const useForceDeleteAirline = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAirlineAction, isPending } = useMutation({
        mutationFn: forceDeleteAirline,
        onSuccess: (res) => {
            const message = res?.message || "Airline permanently deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete airline");
        },
    });

    return { forceDeleteAirline: forceDeleteAirlineAction, isPending };
};

export default useForceDeleteAirline;
